export const wormholeTree = {
  id: 'wormhole',
  label: 'Wormhole',
  type: 'Speculative Spacetime Feature',
  summary: 'A fictional city-scale Einstein-Rosen bridge staged near Saturn, drawn as a gravitational lens that shows another galaxy through its throat.',
  payload: [
    {
      type: 'action',
      label: 'Enter wormhole',
      action: 'enter-wormhole',
      tone: 'primary'
    },
    {
      type: 'description',
      text: 'This is a speculative exhibit object, not a known Solar System body. The mouth has no surface. Light passing close to it is bent by the wormhole itself: rays aimed at the throat arrive from another galaxy, and the rest curve around the mouth, so our own stars crowd into an Einstein ring just outside its edge. The bending is computed from the wormhole geometry built for Interstellar (James, von Tunzelmann, Franklin and Thorne, 2015), with the film\'s length and lensing width.'
    },
    {
      type: 'callout',
      tone: 'info',
      text: 'The visual is inspired by the near-Saturn wormhole concept from Interstellar, but it is generated procedurally for this viewer rather than copied from the film.'
    },
    {
      type: 'stats',
      label: 'Scene placement',
      entries: [
        { label: 'Classification', value: 'Fictional Einstein-Rosen bridge' },
        { label: 'Scene location', value: 'Outer Solar System, near Saturn orbit' },
        { label: 'Scale', value: 'City-scale fictional mouth' },
        { label: 'Visual model', value: 'Ray-traced gravitational lens (Dneg wormhole)' },
        { label: 'Scientific status', value: 'Hypothetical; no observed wormholes are known' }
      ]
    }
  ],
  children: [
    {
      id: 'why-spherical',
      label: 'Why it is spherical',
      summary: 'A wormhole entrance would lens light in every direction, not sit like a flat door.',
      payload: [
        {
          type: 'description',
          text: 'A traversable wormhole mouth is usually imagined as a three-dimensional opening in space. From the outside it would read more like a sphere of distorted background light than a flat portal.'
        }
      ]
    },
    {
      id: 'fiction-vs-physics',
      label: 'Fiction vs physics',
      summary: 'The idea is mathematically motivated, but not known to exist.',
      payload: [
        {
          type: 'description',
          text: 'Einstein-Rosen bridges appear in general relativity, but making a stable, traversable wormhole would require conditions far beyond known engineering and possibly exotic matter. This object is included as a cinematic/speculative feature rather than a catalogue body.'
        }
      ]
    },
    {
      id: 'references',
      label: 'External references',
      summary: 'Where to dig deeper',
      payload: [
        {
          type: 'links',
          entries: [
            { label: 'James et al. 2015: Visualizing Interstellar\'s Wormhole', url: 'https://arxiv.org/abs/1502.03809' },
            { label: 'NASA: Black holes overview', url: 'https://science.nasa.gov/universe/black-holes/' },
            { label: 'Wikipedia: Wormhole', url: 'https://en.wikipedia.org/wiki/Wormhole' },
            { label: 'Wikipedia: Einstein-Rosen bridge', url: 'https://en.wikipedia.org/wiki/Wormhole#Schwarzschild_wormholes' }
          ]
        }
      ]
    }
  ]
};
